import { render, staticRenderFns } from "./ContentEditorClassic.vue?vue&type=template&id=1c38a8b6&"
import script from "./ContentEditorClassic.vue?vue&type=script&lang=js&"
export * from "./ContentEditorClassic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContentEditorClassic.vue"
export default component.exports